import React, { useEffect } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import CheckBoxHookForm from "../../../../components/CheckBoxHookForm";
import CheckboxForCarrierStateAppointedForm from "../../../../components/CheckboxForCarrierStateAppointedForm";
import MinusButton from "../../../../components/MinusButton";
import PlusButton from "../../../../components/PlusButton";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import TextInputLabelCarrierForm from "../../../../components/TextInputLabelCarrierForm";
import { ICarrierStateAppointed } from "../types";

interface CarrierStateAppointedProps {
  stateAppointed: Array<ICarrierStateAppointed>;
}
const CarrierStateAppointedForm = ({
  stateAppointed,
}: CarrierStateAppointedProps): JSX.Element => {
  const useFormMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormMethods;
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name:
      stateAppointed.length > 0 && stateAppointed[0].tableName
        ? stateAppointed[0].tableName
        : "",
  });

  const tableArray =
    stateAppointed.length > 0 && watch(`${stateAppointed[0].tableName}`);
  const controlledFields =
    tableArray &&
    fields.map((field, index) => ({
      ...field,
      ...tableArray[index],
    }));
  useEffect(() => {
    if (stateAppointed) {
      replace(stateAppointed);
    }
  }, [stateAppointed]);
  return (
    <>
      {controlledFields &&
        controlledFields.map((field, index) => {
          return (
            <div className="grid sm:grid-cols-10 py-1 pr-2" key={field.id}>
              <div className="col-span-1 grid sm:grid-cols-2 px-2">
                <div
                  className={`col-span-1 item-center w-1/2 ml-5 ${
                    index < 1 && stateAppointed[0].parentRow === true && "mt-4"
                  }`}
                >
                  {index > 0 ? (
                    <MinusButton type="button" onClick={() => remove(index)} />
                  ) : (
                    <PlusButton
                      type="button"
                      onClick={(e) =>
                        append({
                          tableName: stateAppointed[0]?.tableName,
                          parentRow: false,
                        })
                      }
                    />
                  )}
                </div>
                {stateAppointed[0].tableName?.includes("stateAppointed_") && (
                  <div className="col-span-1">
                    <div
                      className={`grid grid-cols-1 w-full items-center gap-1 text-xs`}
                    >
                      {index < 1 && stateAppointed[0].parentRow === true && (
                        <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                          State
                        </label>
                      )}
                      <TextInputHookFormDisabled
                        type="text"
                        register={register(
                          `${stateAppointed[0].tableName}[${0}].states`,
                          {}
                        )}
                        className="font-bold"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="col-span-9 grid sm:grid-cols-6 content-center gap-x-2">
                <div className="flex justify-center">
                  <CheckboxForCarrierStateAppointedForm
                    label={
                      index < 1 && stateAppointed[0].parentRow === true
                        ? "New Business"
                        : undefined
                    }
                    name={`${stateAppointed[0].tableName}[${index}].newBusiness`}
                    register={register}
                    className={
                      errors?.[stateAppointed[0]?.tableName ?? ""] &&
                      errors?.[stateAppointed[0]?.tableName ?? ""][index]
                        ?.name &&
                      "border-2 border-red-500 col-span-2"
                    }
                  />
                </div>

                <div className="flex justify-center">
                  <CheckboxForCarrierStateAppointedForm
                    label={
                      index < 1 && stateAppointed[0].parentRow === true
                        ? "Renewal Business"
                        : undefined
                    }
                    name={`${stateAppointed[0].tableName}[${index}].renewalBusiness`}
                    register={register}
                    className={
                      errors?.[stateAppointed[0]?.tableName ?? ""] &&
                      errors?.[stateAppointed[0]?.tableName ?? ""][index]
                        ?.name &&
                      "border-2 border-red-500 col-span-2"
                    }
                  />
                </div>
                <div className="flex justify-center">
                  <Controller
                    name={`${stateAppointed[0].tableName}[${index}].newBusinessSuspended`}
                    control={control}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <CheckboxForCarrierStateAppointedForm
                        label={
                          index < 1 && stateAppointed[0].parentRow === true
                            ? "New Business Suspended"
                            : undefined
                        }
                        name={`${stateAppointed[0].tableName}[${index}].newBusinessSuspended`}
                        register={register}
                        className={
                          errors?.[stateAppointed[0]?.tableName ?? ""] &&
                          errors?.[stateAppointed[0]?.tableName ?? ""][index]?.[
                            `newBusinessSuspended`
                          ] &&
                          "border-2 border-red-500 col-span-2"
                        }
                        onClick={(e) => {
                          if (!e.target.checked) {
                            setValue(
                              `${stateAppointed[0].tableName}[${index}].newBusinessSuspendedDate`,
                              ""
                            );
                          }
                        }}
                      />
                    )}
                  />
                </div>
                <div className="flex flex-row items-center">
                  <Controller
                    name={`${stateAppointed[0].tableName}[${index}].newBusinessSuspendedDate`}
                    control={control}
                    rules={{
                      required: watch(
                        `${stateAppointed[0].tableName}[${index}].newBusinessSuspended`
                      )
                        ? true
                        : false,
                    }}
                    render={({ field }) => (
                      <TextInputLabelCarrierForm
                        name={`${stateAppointed[0].tableName}[${index}].newBusinessSuspendedDate`}
                        label={
                          index < 1 && stateAppointed[0].parentRow === true
                            ? "New Business Suspended Date:"
                            : undefined
                        }
                        type="date"
                        register={register(
                          `${stateAppointed[0].tableName}[${index}].newBusinessSuspendedDate`,
                          {}
                        )}
                        className={
                          errors?.[stateAppointed[0]?.tableName ?? ""] &&
                          errors?.[stateAppointed[0]?.tableName ?? ""][index]?.[
                            `newBusinessSuspendedDate`
                          ] &&
                          "border-2 border-red-500 col-span-2"
                        }
                        onChange={(e) => {
                          field.onChange(e ? e.target.value : "");
                        }}
                        required={
                          watch(
                            `${stateAppointed[0].tableName}[${index}].newBusinessSuspended`
                          )
                            ? true
                            : false
                        }
                        disabled={
                          watch(
                            `${stateAppointed[0].tableName}[${index}].newBusinessSuspended`
                          )
                            ? false
                            : true
                        }
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default CarrierStateAppointedForm;
